import { Variables } from '../../../styles/variables'
import styled from "styled-components";

interface Props extends React.ComponentPropsWithoutRef<'div'> {
    countInitiatives: number
}

export const Container = styled.div<Props>`
position: relative;
min-height: calc(100vh - 171px);
padding-bottom: 83px;

.ui {
    &.form {
        position: unset;

        .obs {
            font-size: 12px;
            line-height: 16px;
            letter-spacing: 0.4px;
            color: #79747E;
        }

        .field {
            margin-bottom: 14px;

            &.dropdown-initiatives {
                .multiple {
                    &.dropdown {
                        &::after {
                            content: '${props => props.countInitiatives}';
                            display: ${props => props.countInitiatives > 0 ? 'block' : 'none'};
                            width: 30px;
                            text-align: center;
                            position: absolute;
                            background: ${Variables.yellow};
                            color: ${Variables.gray};
                            padding: 5px;
                            border-radius: 4px;
                            font-size: 14px;
                            font-weight: 600;
                            right: 42px;
                        }
                    }
                }
            }
        }

        .footer {
            width: 100%;
            position: absolute;
            bottom: 28px;

            .btn-actions {
                display: flex;
            }
        }

        .new-initiatives {
            position: relative;
            top: 0px;
            display: flex;
            flex-direction: column;
            align-items: baseline;
            padding: 24px;
            width: 100%;
            height: auto;
            background: #F1F2F4;
            border-radius: 20px;

            .text {
                letter-spacing: 0.1px;
                color: #49454F;
                margin-bottom: 16px;
            }

            .initiatives-list-others {
                margin-bottom: 21px;

                .initiatives-list,
                .initiatives-others {
                    width: 100%;
                }
            }   

            .other-input {
                width: 100%;
                border-bottom: 0.5px solid ${Variables.gray};

                .field {
                    margin-bottom: 0px;
                }

                .labeled {
                    &.input {
                        .label,
                        input {
                            padding: 0px;
                            background: transparent;
                            border: unset;
                        }
                        
                        input {
                            font-size: 14px;
                            line-height: 20px;
                            width: calc(100% - 70px);
                            margin-bottom: 6px;
                            padding-right: 10px;
                        }

                        .label {
                            .prefixo {
                                font-size: 12px;
                                line-height: 16px;
                                margin-top: 2px;
                                margin-right: 8px;
                            }

                            &.add-icon {
                                img {
                                    width: 16px !important;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

.modal {
    &.new-account-modal {
        .modal-dialog {
            width: 412px;
            .modal-content {
                padding: 30px;
            }
        }
    }
}

@media (max-width: 575.99px) {
    .ui {
        &.form {
            .new-initiatives {
                position: relative;
            }
        }
    }

    .modal {
        &.new-account-modal {
            .modal-dialog {
                width: 100%;
                margin: 0px;
                
                .modal-content {
                    padding: 20px;
                }
            }
        }
    }
}
`